import { useTranslation } from 'react-i18next'

import { ClockIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'
import { statuses } from '@/returns/constants'

const OnHold = ({ onHold, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      status={statisticStatuses.warning}
      Icon={ClockIcon}
      label={t('En espera')}
      value={<AnimatedNumber target={onHold} format="decimal" />}
      showStatusIcon
      onClick={() => onClick(statuses.onHold)}
    />
  )
}

export default OnHold
